import { PmsTooltip } from '@/components/ui/pms-tooltip';
import { useFlag } from '@/lib/feature-flags';
import { useEffect, useState } from 'react';
import { DevPanelSheet } from './dev-panel-sheet';

/**
 * App-wide dev panel: a floating launcher (bottom-right, above the dev ModeBadge)
 * that opens an overlay to toggle feature flags and tweaks live. Mounted once in
 * main.tsx, outside the router, so it sits over every route.
 *
 * The launcher hides while the panel is open (the panel replaces it), and can also
 * be hidden permanently via the reactive `dev_panel_hidden` flag. Either way,
 * Ctrl/Cmd+Shift+. toggles the panel — the escape hatch when no button is visible.
 */
export function DevPanel() {
  const [open, setOpen] = useState(false);
  const hidden = useFlag('dev_panel_hidden');

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      // Ctrl/Cmd + Shift + .  — uses `code` so it is layout-independent.
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.code === 'Period') {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      {!hidden && !open && (
        <div className="devp-launcher-wrap">
          <PmsTooltip label="Dev panel (Ctrl/Cmd+Shift+.)" side="top">
            <button
              type="button"
              className="devp-launcher"
              aria-label="Open dev panel"
              onClick={() => setOpen(true)}
            >
              <span className="material-symbols-rounded">tune</span>
            </button>
          </PmsTooltip>
        </div>
      )}
      {open && <DevPanelSheet onClose={() => setOpen(false)} />}
    </>
  );
}
